import { render, staticRenderFns } from "./computationNum.vue?vue&type=template&id=8ae72c1e&scoped=true&"
import script from "./computationNum.vue?vue&type=script&lang=js&"
export * from "./computationNum.vue?vue&type=script&lang=js&"
import style0 from "./computationNum.vue?vue&type=style&index=0&id=8ae72c1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae72c1e",
  null
  
)

export default component.exports